var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfiniband = function SvgInfiniband(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H9H7.5M12 18H15H16.5M12 18V21M7.5 18H5.75L5.75 6.5H7V4.75H17V6.5H18.25V12.25C18.25 12.5152 18.25 17.5839 18.25 18H16.5M7.5 18C7.5 14 9 11.5 9.75 10.75C11.5074 10.75 14.25 10.75 14.25 10.75C15.0417 11.5 16.5 14 16.5 18M13.5 15H10.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgInfiniband;